import secrets from '../config/secrets'

const sortListAlgolia = [
  { value: secrets.ALGOLIA_INDEX_NAME, label: 'Destacados' },
  { value: `${secrets.ALGOLIA_INDEX_NAME}_price_asc`, label: 'Precio menor a mayor' },
  { value: `${secrets.ALGOLIA_INDEX_NAME}_price_desc`, label: 'Precio mayor a menor' },
]

export default sortListAlgolia
